import angular from 'angular';
import component from './threshold-builder.component';

const thresholdBuilderModule = angular
    .module('dt.components.organization-alert-config.threshold-builder', [])
    .component('thresholdBuilder', component);

export default thresholdBuilderModule.name;
